import { useEffect, useRef, useState } from "react";

export const useStripeInit = (paymentVariation, isEnabled = true) => {
    const singletonRef = useRef(false);
    const [paymentData, setPaymentData] = useState(null);

    useEffect(() => {
        if (typeof window === 'undefined' || !paymentVariation || singletonRef.current || !isEnabled) {
            return;
        }

        singletonRef.current = true;

        fetch(`${process.env.NEXT_PUBLIC_PAYMENT_URL}/init?variation=${paymentVariation}`)
            .then(res => res.json())
            .then(data => {
                setPaymentData(data);
            });
    }, [paymentVariation]);

    return paymentData;
};
